import tableRowRules from '../../table/row-line';

const primary = (params) => tableRowRules.primary(params);

export default primary;
